import { Controller, useFormContext } from 'react-hook-form'

import { Component } from './Component'

import type { TextareaProps } from './types'

export const Textarea = ({ name, label, required, error, hasController = true, ...rest }: TextareaProps) => {
  if (hasController) {
    const { control } = useFormContext()

    return (
      <Controller
        name={name}
        control={control}
        render={({ field, formState: { errors } }) => (
          <Component
            name={name}
            label={label}
            required={required}
            error={errors[name]?.message as string | undefined}
            value={field.value}
            onChange={field.onChange}
            onBlur={field.onBlur}
            {...rest}
          />
        )}
      />
    )
  }

  return <Component name={name} label={label} required={required} error={error} {...rest} />
}
